module.exports = __webpack_public_path__ + "static/img/iwatch_Series5.8839bb00.jpg";